import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { apiFetch, useError } from '../../admin-page/apis/api';

export const BADGE_COMPLETION_QUERY_KEY = ['badgeCompletion'];

const normalizeBadgeCompletions = (responseData) => {
  const completions = Array.isArray(responseData)
    ? responseData
    : Array.isArray(responseData?.modules)
      ? responseData.modules
      : responseData?.moduleNumber !== undefined
        ? [responseData]
        : [];

  return completions
    .map((completion) => ({
      moduleNumber: Number(completion?.moduleNumber),
      dateCompleted: completion?.dateCompleted ?? null,
    }))
    .filter(
      (completion) =>
        Number.isInteger(completion.moduleNumber) &&
        completion.moduleNumber >= 1 &&
        completion.moduleNumber <= 6,
    )
    .sort((left, right) => left.moduleNumber - right.moduleNumber);
};

const getBadgeCompletions = async () => {
  const response = await apiFetch(
    `${process.env.REACT_APP_API_URL}/api/badge/completion`,
    {
      method: 'GET',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  return response.status === 204 ? [] : response.json();
};

export const useBadgeCompletionQuery = ({ enabled = true } = {}) => {
  const { checkError } = useError();
  const query = useQuery({
    queryKey: BADGE_COMPLETION_QUERY_KEY,
    queryFn: getBadgeCompletions,
    select: normalizeBadgeCompletions,
    retry: false,
    refetchOnMount: 'always',
    enabled,
  });

  useEffect(() => {
    if (enabled && query.error) {
      checkError(query.error);
    }
  }, [checkError, enabled, query.error]);

  return query;
};
